import { Interval } from '@/pages/OperationsInsights/types/Interval';

export const getLabelByInterval = (interval: Interval) => {
    switch (interval) {
        case Interval.Day:
            return 'Day';
        case Interval.Week:
            return 'Week';
        case Interval.Month:
            return 'Month';
        default:
            return '';
    }
};